import { service } from './base-service'

const getFeatureFlag = async (key) => {
  try {
    const { data } = await service.get(`/v2/system-features/${key}`)
    return Boolean(data.enabled)
  } catch {
    return false
  }
}

export { getFeatureFlag }
